import React from 'react';
import { useTranslation } from 'react-i18next';
import Flickity from 'react-flickity-component';
import { WithIntl } from './language/with-intl.js';

const Testimonials = () => {
    const { t } = useTranslation();

    return (
        <Flickity
            className="testimonial-slider position-static"
            options={{
                wrapAround: true,
                pageDots: false,
                autoPlay: 3000,
                draggable: false
            }}
            static
        >
            <div className="w-100">
                <blockquote className="blockquote mx-0 mx-md-auto">
                    <p className="text-gray-700" id="testimonial_1">
                        {'"' + t('home.testimonials.testimonial_1') + '"'}
                    </p>
                </blockquote>
            </div>
            <div className="w-100">
                <blockquote className="blockquote mx-0 mx-md-auto">
                    <p className="text-gray-700" id="testimonial_2">
                        {'"' + t('home.testimonials.testimonial_2') + '"'}
                    </p>
                </blockquote>
            </div>
            <div className="w-100">
                <blockquote className="blockquote mx-0 mx-md-auto">
                    <p className="text-gray-700" id="testimonial_3">
                        {'"' + t('home.testimonials.testimonial_3') + '"'}
                    </p>
                </blockquote>
            </div>
            <div className="w-100">
                <blockquote className="blockquote mx-0 mx-md-auto">
                    <p className="text-gray-700" id="testimonial_4">
                        {'"' + t('home.testimonials.testimonial_4') + '"'}
                    </p>
                </blockquote>
            </div>
        </Flickity>
    );
};

export default Testimonials;
